import styles from './registrationUpdateInformation.module.css';

export interface RegistrationUpdateInformationProps {
  createdBy: string;
  createdAt: string;
  updatedBy: string | null;
  updatedAt: string | null;
}

function RegistrationUpdateInformation(props: RegistrationUpdateInformationProps) {
  const {
    createdBy, createdAt, updatedBy, updatedAt,
  } = props;
  return (
    <div className={styles.container}>
      <div className={styles.col}>
        <div>
          <div className={styles.title}>登録者</div>
          <div className={styles.val}>{createdBy}</div>
        </div>
        {
          updatedBy != null && (
            <div>
              <div className={styles.title}>更新者</div>
              <div className={styles.val}>{updatedBy}</div>
            </div>
          )
        }
      </div>
      <div className={styles.col}>
        <div>
          <div className={styles.title}>登録日時</div>
          <div className={styles.val}>{createdAt}</div>
        </div>
        {
          updatedAt != null && (
            <div>
              <div className={styles.title}>更新日時</div>
              <div className={styles.val}>{updatedAt}</div>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default RegistrationUpdateInformation;
